module.exports = __webpack_public_path__ + "static/media/harshal_kausadikar.082f547a.jpg";